import styles from "./styles.module.scss";

const Label = ({ htmlFor, children, required = false }: any) => {
  return (
    <label className={styles.text} htmlFor={htmlFor}>
      {children}
      <span className={styles.required}>{required ? "*" : ""}</span>
    </label>
  );
};

export default Label;
